import { Component, Input, OnInit } from "@angular/core";
import { AgreementsService } from "../../../../shared/services/agreements.service";
import { AgreementSummaryDto } from "../../../../shared/models/agreement/agreement-summary.dto";
import { NotificationService } from "../../../../core/services/notification.service";

@Component({
    selector: 'agreement-summary',
    templateUrl: './agreement-summary.component.html',
    styleUrls: [
        './agreement-summary.component.scss',
        '../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
    ]
})
export class AgreementSummaryComponent implements OnInit {

    @Input() agreementId: number;
    @Input() isReadonly: boolean = false;

    summary: AgreementSummaryDto;
    createServiceRequestLoading: boolean;

    constructor(
        private agreementsService: AgreementsService,
        private notificationService: NotificationService
    ) { }

    ngOnInit(): void {
        this.agreementsService.getAgreementSummary(this.agreementId).subscribe(resp => {
            this.summary = resp;
        });
    }
}